(function () {
  var SELECTOR = '[data-kevilagu-footer]';
  var GSAP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var SCROLLTRIGGER_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || root.dataset.klFooterReady === 'true' || typeof window.gsap === 'undefined') return;
    root.dataset.klFooterReady = 'true';

    if (reducedMotion()) return;

    var gsap = window.gsap;
    var items = root.querySelectorAll('[data-kl-footer-animate]');

    if (!window.ScrollTrigger || !items.length) return;

    window.gsap.registerPlugin(window.ScrollTrigger);

    gsap.fromTo(
      items,
      { autoAlpha: 0, y: 24 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.08,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: root,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      }
    );
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  function loadScript(src, marker) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('script[data-' + marker + ']');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
        } else {
          existing.addEventListener('load', resolve, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset[marker] = 'true';
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      document.head.appendChild(script);
    });
  }

  function loadGsap(callback) {
    if (window.gsap && window.ScrollTrigger) {
      callback();
      return;
    }

    var gsapReady = window.gsap ? Promise.resolve() : loadScript(GSAP_SRC, 'kevilaguGsap');

    gsapReady
      .then(function () {
        return window.ScrollTrigger ? Promise.resolve() : loadScript(SCROLLTRIGGER_SRC, 'kevilaguScrollTrigger');
      })
      .then(function () {
        if (window.gsap && window.ScrollTrigger) {
          window.gsap.registerPlugin(window.ScrollTrigger);
        }
        callback();
      });
  }

  function boot() {
    loadGsap(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (root) loadGsap(function () { init(root); });
  });
})();
